const TrashIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33325 9.33333H26.6666M13.3333 14.6667V22.6667M18.6666 14.6667V22.6667M6.66659 9.33333L7.99992 25.3333C7.99992 26.0406 8.28087 26.7189 8.78097 27.219C9.28106 27.719 9.95934 28 10.6666 28H21.3333C22.0405 28 22.7188 27.719 23.2189 27.219C23.719 26.7189 23.9999 26.0406 23.9999 25.3333L25.3333 9.33333M11.9999 9.33333V5.33333C11.9999 4.97971 12.1404 4.64057 12.3904 4.39052C12.6405 4.14048 12.9796 4 13.3333 4H18.6666C19.0202 4 19.3593 4.14048 19.6094 4.39052C19.8594 4.64057 19.9999 4.97971 19.9999 5.33333V9.33333"
      stroke="#575A61"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrashIcon;
